import CryptoAssetComponentDashboard from "./CryptoAssetsDashboard";
import MarketDashboard from "./MarketDashboard";

export default function CryptoDashboard() {
  return (
    <div className="w-full flex justify-between flex-wrap gap-4">
      <MarketDashboard />
      <CryptoAssetComponentDashboard styleClasses="lg:w-[34%]" />
    </div>
  );
}
